import React from 'react';
import Typography from "@material-ui/core/Typography";
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import styles from './SkipContentLink.module.css';

const SkipContentlink = ({ id, children = 'Skip to content', ...props }) => {
  return (
    <a title="Skip to content" {...props} href={`#${id}`} tabIndex="0" className={styles.skipContentLinkEW}>
      <Typography
          variant="body1"
          gutterBottom
          color="primary"
      >
          {children}
          <ChevronRightOutlinedIcon color="primary" />
      </Typography>
    </a>
  );
};

export default SkipContentlink;
